import {useEffect, useRef} from 'react';
import {useAppSelector} from '../../../hooks/useTypedReactRedux';
import {RootState} from '../../../store';
import {accountsSelector} from '../../accounts/selectors';
import {checkMultipleAccountSessions} from '../services/AccountSessionService';
import {clearInvalidSession} from '../services/clearInvalidSession';

/**
 * Validates all account sessions once on app load.
 * Renders inside the Router so it has access to navigation context if ever needed.
 * Clears invalid sessions automatically without affecting valid ones.
 */
export const SessionValidator = () => {
    const accounts = useAppSelector((state: RootState) => accountsSelector(state));
    const hasValidated = useRef(false);

    useEffect(() => {
        if (hasValidated.current || !accounts || accounts.length === 0) return;
        hasValidated.current = true;

        const validateAll = async () => {
            console.log('LOGIN APP. VALIDATING ALL ACCOUNT SESSIONS ON LOAD', accounts.length);

            try {
                const results = await checkMultipleAccountSessions(accounts);

                for (const result of results) {
                    if (!result.isActive) {
                        const account = accounts.find(a => a.id === result.accountId);
                        if (account && account.updatedAt) {
                            console.log('LOGIN APP. AUTO-CLEARING INVALID SESSION ON LOAD', account.emailAddress);
                            await clearInvalidSession(account);
                        }
                    }
                }
            } catch (error) {
                console.trace('LOGIN APP. SESSION VALIDATION ON LOAD ERROR', error);
            }
        };

        validateAll();
    }, [accounts]);

    return null;
};
